module.exports = "/_next/static/images/syudan-fa4efb90ab167a377c09f5ef1fc19296.jpg";